import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../services/analytics.service';

// Map routes to page titles for better readability in GA4
const PAGE_TITLES = {
    '/': 'Inicio',
    '/sign-in': 'Iniciar Sesión',
    '/search': 'Buscar Pedidos',
    '/success': 'Confirmación',
    '/roscas': 'Nueva Rosca',
    '/roscas/roscaOrders': 'Pedidos de Roscas',
    '/panaderos': 'Vista Panaderos',
    '/panaderos-v2': 'Vista Panaderos V2',
    '/panes': 'Nuevo Pan',
    '/custom-orders': 'Pedidos Especiales',
    '/settings': 'Configuración',
    '/merchant-orders': 'Pedidos Mayoreo',
    '/product-catalog': 'Catálogo de Productos',
    '/hq-consolidation': 'Consolidación HQ',
    '/analytics': 'Métricas'
};

/**
 * Hook that logs page views to Firebase Analytics on route changes
 */
export function useAnalyticsPageView() {
    const location = useLocation();

    useEffect(() => {
        const pagePath = location.pathname;
        const pageTitle = PAGE_TITLES[pagePath] || document.title || 'Los Portales';

        logPageView(pagePath, pageTitle);
    }, [location.pathname]);
}

export default useAnalyticsPageView;
